import { useWindowDimensions } from 'react-native';
import theme from '../util/theme';

export default (breakpoint: keyof typeof theme.breakpoints) =>
  useWindowDimensions().width >= theme.breakpoints[breakpoint];
